module.exports = __webpack_public_path__ + "img/swipe4.f59cd2f7.png";